import { render, staticRenderFns } from "./AttachmentDialog.vue?vue&type=template&id=14efc4d1&scoped=true&"
import script from "./AttachmentDialog.vue?vue&type=script&lang=js&"
export * from "./AttachmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentDialog.vue?vue&type=style&index=0&id=14efc4d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14efc4d1",
  null
  
)

export default component.exports